import { post } from "./baseService";

export async function addComment(data) {
  const response = await post(`comments`, data, true);
  return response;
}
